var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.isWebView)?_c('div',{ref:"ad",staticClass:"flex justify-center flex-col",class:{ 'mt-8 mb-4 lg:mt-12 lg:mb-4': !!_vm.adClientHeight }},[_c('div',{staticClass:"hidden lg:block"},[_c('div',{attrs:{"id":_vm.desktopId}})]),_vm._v(" "),_c('div',{staticClass:"block lg:hidden"},[_c('div',{attrs:{"id":_vm.mobileId}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }